import { render, staticRenderFns } from "./JobStatusSticker.vue?vue&type=template&id=5175af2b&scoped=true&"
import script from "./JobStatusSticker.vue?vue&type=script&lang=js&"
export * from "./JobStatusSticker.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusSticker.vue?vue&type=style&index=0&id=5175af2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175af2b",
  null
  
)

export default component.exports